import Loader from "components/global/Loader";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
  height: 100vh;
`;

const mobileRedirectScreens = {
  connectChannelOnboarding: "postpaddy.app://(brands)/screen-two",
  connectChannelbrandManagement: "postpaddy.app://brandsManagement/[brand]",
};

const MobileRedirect = () => {
  const { search } = useLocation();
  const routeKey = new URLSearchParams(search).get("route");

  useEffect(() => {
    try {
      window.location.replace(`${mobileRedirectScreens[routeKey]}${search}`);
    } catch (e) {
      console.log(e);
      window.location.replace("/");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Wrapper>
      <div className="centralize">
        <Loader />
      </div>
    </Wrapper>
  );
};

export default MobileRedirect;
